<script>
	import { page } from '$app/stores';
	import BuildingIcon from '$lib/components/icons/BuildingIcon.svelte';
	import CalendarIcon from '$lib/components/icons/CalendarIcon.svelte';
	import UsersIcon from '$lib/components/icons/UsersIcon.svelte';
	import PresentationIcon from '$lib/components/icons/PresentationIcon.svelte';
	import ClipboardCheckIcon from '$lib/components/icons/ClipboardCheckIcon.svelte';
	import RefreshIcon from '$lib/components/icons/RefreshIcon.svelte';
	import CogIcon from '$lib/components/icons/CogIcon.svelte';
	import DocumentIcon from '$lib/components/icons/DocumentIcon.svelte';
	import PencilIcon from '$lib/components/icons/PencilIcon.svelte';
	import HomeIcon from '$lib/components/icons/HomeIcon.svelte';
	import FolderIcon from '$lib/components/icons/FolderIcon.svelte';
	import CreditCardIcon from '$lib/components/icons/CreditCardIcon.svelte';
	export let item;
	export let onClick = () => {};

	const icons = {
		BuildingIcon,
		CalendarIcon,
		UsersIcon,
		PresentationIcon,
		ClipboardCheckIcon,
		RefreshIcon,
		CogIcon,
		DocumentIcon,
		PencilIcon,
		HomeIcon,
		FolderIcon,
		CreditCardIcon
	};

	let isExpanded = false;

	$: isActive = item.href === '/dashboard'
		? $page.url.pathname === '/dashboard'
		: $page.url.pathname.startsWith(item.href);
	$: hasChildren = item.children && item.children.length > 0;
	$: alwaysExpanded = item.alwaysExpanded === true;
	$: IconComponent = icons[item.icon];

	// 하위 메뉴가 있고 현재 경로가 해당 메뉴의 하위 경로면 자동 펼침
	$: if (hasChildren && (isActive || alwaysExpanded)) {
		isExpanded = true;
	}

	let clickTimer = null;
	let itemEl;

	function scrollChildrenIntoView() {
		requestAnimationFrame(() => {
			if (itemEl) {
				const lastChild = itemEl.querySelector('div > a:last-child');
				if (lastChild) {
					lastChild.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				}
			}
		});
	}

	function handleParentClick(e) {
		if (!hasChildren || alwaysExpanded) return;

		e.preventDefault();

		if (clickTimer) {
			// 더블클릭: 페이지 이동
			clearTimeout(clickTimer);
			clickTimer = null;
			onClick();
			window.location.href = item.href;
		} else {
			// 싱글클릭 대기: 서브메뉴 토글
			clickTimer = setTimeout(() => {
				isExpanded = !isExpanded;
				clickTimer = null;
				if (isExpanded) {
					scrollChildrenIntoView();
				}
			}, 250);
		}
	}

	$: currentPath = $page.url.pathname;
</script>

<div bind:this={itemEl}>
	<a
		href={item.href}
		on:click={(e) => {
			if (hasChildren && !alwaysExpanded) {
				handleParentClick(e);
			} else {
				onClick();
			}
		}}
		class="flex items-center justify-between px-4 py-1.5 rounded-lg transition-colors
			{isActive ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover'}"
	>
		<div class="flex items-center gap-3">
			<svelte:component this={IconComponent} class="w-5 h-5" />
			<span class="font-medium">{item.label}</span>
		</div>
		{#if hasChildren && !alwaysExpanded}
			<svg
				class="w-4 h-4 transition-transform {isExpanded ? 'rotate-180' : ''}"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
			>
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
			</svg>
		{/if}
	</a>

	{#if hasChildren && isExpanded}
		<div class="ml-4 mt-1 space-y-1">
			{#each item.children as child (child.id)}
				{@const isChildActive = currentPath === child.href || (currentPath.startsWith(child.href + '/') && child.href !== item.href)}
				<a
					href={child.href}
					on:click={onClick}
					class="flex items-center gap-3 px-4 py-1 rounded-lg transition-colors text-sm
						{isChildActive ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover'}"
				>
					<span class="w-5 h-5 flex items-center justify-center">
						<span class="w-1.5 h-1.5 rounded-full {isChildActive ? 'bg-blue-500' : 'bg-gray-400'}"
						></span>
					</span>
					<span>{child.label}</span>
				</a>
			{/each}
		</div>
	{/if}
</div>
